import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import HqBudgetInputContainer from '../../containers/hq-budget-input/HqBudgetInputContainer';

const HeadquarterBudgetInputPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="판관비 관리/본부 예산 관리" icon="budget" />
      <HqBudgetInputContainer />
    </>
  );
};

export default HeadquarterBudgetInputPage;
